"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getStyles = void 0;

var tslib_1 = require("tslib");

var ui_symbols_1 = require("@hopin-team/ui-symbols");

var custom_input_1 = require("../custom-input");

var menuBoxShadow = '0 0.0625rem 0.1875rem rgba(44, 50, 66, 0.15), 0 0.5rem 1rem rgba(44, 50, 66, 0.08)'; // undefined values unset the provided CSS, so our styled component can set it.

function getStyles(size, styles) {
  return {
    dropdownIndicator: function dropdownIndicator(provided) {
      var color = undefined;
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        color: color,
        '&:hover': {
          color: color
        }
      });
    },
    clearIndicator: function clearIndicator(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        color: undefined,
        '&:hover': {
          color: undefined
        }
      });
    },
    indicatorsContainer: function indicatorsContainer(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        padding: 0,
        paddingRight: '1.125rem'
      });
    },
    placeholder: function placeholder(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        color: undefined,
        marginLeft: 0
      });
    },
    input: function input(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        '& input': {
          height: 'unset'
        },
        '& input:focus': {
          boxShadow: 'none'
        }
      });
    },
    control: function control(provided, state) {
      var _a, _b;

      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        height: state.isMulti ? '100%' : (0, ui_symbols_1.calcSpace)(custom_input_1.Sizes[size]),
        alignContent: 'center',
        boxShadow: undefined,
        borderColor: undefined,
        borderRadius: undefined,
        '&:hover': {
          boxShadow: undefined
        },
        paddingLeft: ((_b = (_a = state.selectProps) === null || _a === void 0 ? void 0 : _a.controlProps) === null || _b === void 0 ? void 0 : _b.icon) ? '1rem' : undefined
      });
    },
    menu: function menu(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        borderRadius: '0.75rem',
        boxShadow: menuBoxShadow
      });
    },
    menuList: function menuList(provided, state) {
      return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, provided), {
        paddingTop: 0,
        paddingBottom: 0
      }), styles && styles.menuList && styles.menuList(provided, state));
    },
    singleValue: function singleValue(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        color: undefined
      });
    },
    multiValue: function multiValue(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        backgroundColor: undefined
      });
    },
    multiValueLabel: function multiValueLabel(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        fontSize: '0.875rem',
        lineHeight: '1.125rem',
        fontWeight: 500,
        paddingRight: 0,
        color: undefined
      });
    },
    multiValueRemove: function multiValueRemove(provided) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        paddingLeft: 8,
        paddingRight: 8,
        color: undefined,
        '&:hover': {
          backgroundColor: 'transparent',
          color: undefined
        }
      });
    },
    valueContainer: function valueContainer(provided, state) {
      return tslib_1.__assign(tslib_1.__assign({}, provided), {
        padding: state.isMulti && state.hasValue ? '0.5rem' : '0.25rem 1rem'
      });
    },
    option: function option(provided, state) {
      return tslib_1.__assign(tslib_1.__assign(tslib_1.__assign({}, provided), {
        borderRadius: '0.5rem',
        padding: '0.75rem',
        fontWeight: 600,
        color: undefined
      }), styles && styles.option && styles.option(provided, state));
    }
  };
}

exports.getStyles = getStyles;